import * as _ from "lodash";
import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";


const vUI_Policy_Cube_ProcessSearch_Fields: { [id: string]: ISearchProviderField } = {
    WB_POLICYCUBEPROCESS_ID: {type: SearchProviderFieldType.number, renderOptions: {columnName: 'WB Process Id', alignment: HorizAlignment.Left}, domainOptions: {}},
    PROCESS_ID:     {type: SearchProviderFieldType.string, renderOptions: {columnName: 'ID',  alignment: HorizAlignment.Left}, domainOptions: {maxLength: 50}},
    PROCESS_NAME:   {type: SearchProviderFieldType.string, renderOptions: {columnName: 'Name',  alignment: HorizAlignment.Left}, domainOptions: {maxLength: 256}},
    WB_MDSET_ID:    {type: SearchProviderFieldType.number, renderOptions: {columnName: 'WB MDSet Id', alignment: HorizAlignment.Left},  domainOptions: {}},
    MDSET_NAME:     {type: SearchProviderFieldType.string, renderOptions: {columnName: 'Master Data Set', alignment: HorizAlignment.Left}, domainOptions: {profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 50}},
    WB_SALESORG_ID: {type: SearchProviderFieldType.number, renderOptions: {columnName: 'WB SalesOrg Id', alignment: HorizAlignment.Left}, domainOptions: {}},
    SALESORG_NAME:  {type: SearchProviderFieldType.string, renderOptions: {columnName: 'Sales Org',  alignment: HorizAlignment.Left}, domainOptions: {}},
    COMMENTS:       {type: SearchProviderFieldType.string, renderOptions: {columnName: 'Description', alignment: HorizAlignment.Left}, domainOptions: {maxLength: 5000}},
    SOURCE_GRAIN:   {type: SearchProviderFieldType.string, renderOptions: {columnName: 'Source Grain', alignment: HorizAlignment.Left}, domainOptions: {maxLength: 100}},
    TARGET_GRAIN:   {type: SearchProviderFieldType.string, renderOptions: {columnName: 'Target Grain', alignment: HorizAlignment.Left}, domainOptions: {maxLength: 100}},
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
};

const PolicyCubeProcessSearchProviderBasic: ISearchProvider = {

    keyFields: {
        id:    'WB_POLICYCUBEPROCESS_ID',
        id_ui: 'PROCESS_ID',
        name:  'PROCESS_NAME'
    },

    searchProviderFields: vUI_Policy_Cube_ProcessSearch_Fields,

    async search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {

            let usrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
            if (!usrContext.hasRoleId("VIEW_ALL")) {
                searchRequestSubset.where['WB_SALESORG_ID'] = {inq: _.map(usrContext.WB_SalesOrgs, 'WB_SALESORG_ID')}
            }

            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_PolicyCubeProcess_Search',
                this.searchProviderFields,
                []);

            return await PASearch.findByRequest(findRequest)
    },
    async distinctValues(fieldName: string): Promise<string[] | number[]> {

            let usrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
            let searchRequestSubset: { where?: { [id: string]: any } } = {}
            if (!usrContext.hasRoleId("VIEW_ALL")) {
                searchRequestSubset.where['WB_SALESORG_ID'] = {inq: _.map(usrContext.WB_SalesOrgs, 'WB_SALESORG_ID')}
            }

            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_PolicyCubeProcess_Search',
                this.searchProviderFields,
                [fieldName])


            let res = await PASearch.findByRequest(findRequest)

            return _.map(res, (aRow) => { return aRow[fieldName]})
    }
};

const PolicyCubeProcessSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: {ui5SourceId: "PolicyCubeProcessSearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'ID', searchProviderFieldId: 'PROCESS_ID', renderOptions: {}},
        {profileFilterName: 'Name', searchProviderFieldId: 'PROCESS_NAME', renderOptions: {}},
        {profileFilterName: 'Master Data Set', searchProviderFieldId: 'MDSET_NAME', renderOptions: {}, bMultiSelect: true}
    ], //ISearchFields
    profileDisplayFields: [
        'PROCESS_ID', 'PROCESS_NAME', 'SOURCE_GRAIN', 'TARGET_GRAIN', 'MDSET_NAME', 'SALESORG_NAME',
        'CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: PolicyCubeProcessSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const PolicyCubeProcessSearch: ISearch = {
    searchName: "Find Policy Cube Process",
    renderOptions: {ui5ResourceId: "PolicyCubeProcessSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [PolicyCubeProcessSearchProfileByName]
};

PAEnvironment.registerBusinessObjectSearch("PolicyCubeProcessBO", "PolicyCubeProcess", PolicyCubeProcessSearch, "Policy Cube Process Search")

export {PolicyCubeProcessSearch}

